import React, { useState } from 'react'
import SelectCard from '../Card/SelectCard'
import selfImg from "../../../Assets/SelfOrder/Self.png"
import staffImg from "../../../Assets/SelfOrder/Staffs.png"
import { useDispatch } from 'react-redux'
import { setScreenLoginType, setScreenSelected } from '../../Slices/selfOrderMainSlice'
import { selfOrderClear } from '../../SelfGeneralFunctions'
import AssessmentIcon from '@mui/icons-material/Assessment'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import SummarizeIcon from '@mui/icons-material/Summarize'
import InventoryIcon from '@mui/icons-material/Inventory'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import {
  MobileShiftReport,
  MobileSalesDetails,
  MobilePosSummary,
  MobileProductList,
  MobileShiftSummary
} from '../Reports'
import '../Reports/mobileReports.css'

const LoginType = () => {
  const dispatch = useDispatch()
  const [openReport, setOpenReport] = useState(null)

  const cardClick = (click) => {
    localStorage.setItem("selfUser", click)
    dispatch(setScreenLoginType(click))
    dispatch(setScreenSelected(null))
    selfOrderClear()
  }

  const handleOpenReport = (reportType) => {
    setOpenReport(reportType)
  }

  const handleCloseReport = () => {
    setOpenReport(null)
  }

  return (
    <div className="self-login-ctn">
      <h3>LOGIN TYPE</h3>
      <div className="justify-center" style={{ gap: "15px", flexWrap: "wrap" }}>
        <SelectCard image={selfImg} label="SELF" onClick={() => cardClick("SELF")} />
        <SelectCard image={staffImg} label="STAFF" onClick={() => cardClick("STAFF")} />
      </div>

      {/* Report Icons Row */}
      <div className="report-icons-row">
        <button className="report-icon-btn advance" onClick={() => handleOpenReport('advanceShift')}>
          <TrendingUpIcon />
          <span className="icon-label">Advance Shift</span>
        </button>
        <button className="report-icon-btn sales" onClick={() => handleOpenReport('salesDetails')}>
          <ReceiptLongIcon />
          <span className="icon-label">Sales Details</span>
        </button>
        <button className="report-icon-btn shift" onClick={() => handleOpenReport('shiftReport')}>
          <AssessmentIcon />
          <span className="icon-label">Shift Report</span>
        </button>
        <button className="report-icon-btn summary" onClick={() => handleOpenReport('posSummary')}>
          <SummarizeIcon />
          <span className="icon-label">POS Summary</span>
        </button>
        <button className="report-icon-btn products" onClick={() => handleOpenReport('productList')}>
          <InventoryIcon />
          <span className="icon-label">Products</span>
        </button>
      </div>

      {/* Report Dialogs */}
      <MobileShiftReport 
        open={openReport === 'advanceShift'} 
        onClose={handleCloseReport} 
      />
      <MobileSalesDetails 
        open={openReport === 'salesDetails'} 
        onClose={handleCloseReport} 
      />
      <MobileShiftSummary 
        open={openReport === 'shiftReport'} 
        onClose={handleCloseReport} 
      />
      <MobilePosSummary 
        open={openReport === 'posSummary'} 
        onClose={handleCloseReport} 
      />
      <MobileProductList 
        open={openReport === 'productList'} 
        onClose={handleCloseReport} 
      />
    </div>
  )
}

export default LoginType